import Vue from 'vue';
import { _log } from './util';

const initNearestRetailers = function ()
{
    const el = document.getElementById("vue_nearestRetailer");
    if (!el) {
        return false;
    }
    new Vue({
        el: '#vue_nearestRetailer',
        delimiters: ['[[',']]'],
        data: {
            countryList : null,
            lat : null,
            lng : null,
            nearestDistance : 0,
            cityName : "",
            cityList : null,
            cityOptions : [],
            retailers : [],
            retailerIds : [],
            retailerList : [],
            boutiqueList : [],
            ccByQuery : false,
            today : new Date()
        },

        methods :
        {
            isBoutique : function(item)
            {
                return (item.type==='boutique');
            },

            buildTelLink : function (item, prefix=true)
            {
                const phone = item.country_call_code+item.city_code+item.phone;

                return (prefix) ? 'tel:'+phone : phone;
            },

            buildFaxLink : function (item, prefix=true)
            {
                const fax = (item.country_call_code+item.city_code+item.fax).replace(" ", "");

                return (prefix) ? 'fax:'+fax : fax;
            },

            buildMailtoLink : function (item)
            {
                return 'mailto:' +item.email;
            },

            buildRouteLink : function (item)
            {
                let home = '';
                if (this.center && this.center.lat) {
                    home = `${this.center.lat}, ${this.center.lng}`;
                }
                return `https://www.google.com/maps/dir/?api=1&origin=${home}&destination=${item.lat}, ${item.lng}`;
            },

            toggleLayer: function( id )
            {
                const card = document.getElementById('retailer-'+id);
                card.classList.toggle("active");
            },


            submitContact : function ( event )
            {
                // _log("submit contact ...")
                event.preventDefault();

                let request_data = {
                    // _token: csrf_token,
                    // token: csrf_token,
                    locale          : this.contact_locale,
                    retailer_id     : this.contact_retailer_id,
                    name            : this.contact_name,
                    email           : this.contact_email,
                    phone           : this.contact_phone,
                    message         : this.contact_message
                };

                // console.log(this.contact_api_url);
                // console.log(request_data);
                $.ajax({
                        url: this.contact_api_url,
                        type: 'POST',
                        data: request_data,
                        dataType: 'JSON',
                        success: this.sendContactForm__Callback,
                        error: function() {
                            console.log("error");
                        }
                    }
                );
            },

            sendContactForm__Callback : function ( response )
            {
                if (typeof response === "object") {
                    this.contact_response = response.message;
                }
            },

            getRetailers : function()
            {
                const date = new Date();

                const request_data = {
                    action: 'get_retailers',
                    locale: locale,
                    t: date.getTime(),
                };

                $.ajax({
                    url: xhrUrl,
                    type: 'GET',
                    data: request_data,
                    dataType: 'JSON',
                    success: this.getRetailers__callback,
                });
            },

            getRetailers__callback : function(response)
            {
                if (typeof response === "object") {
                    this.lat = (this.lat) ? this.lat : response.lat;
                    this.lng = (this.lng) ? this.lng : response.lng;
                    this.retailers = response.retailers;
                    this.updateRetailerList();
                }
            },

            getFirstKey : function(data) {
                for (var prop in data) {
                    return prop;
                }
            },

            distance : function (lat1, lon1, lat2, lon2, unit)
            {

                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                }
                else {
                    var radlat1 = Math.PI * lat1/180;
                    var radlat2 = Math.PI * lat2/180;
                    var theta = lon1-lon2;
                    var radtheta = Math.PI * theta/180;
                    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180/Math.PI;
                    dist = dist * 60 * 1.1515;
                    if (unit=="K") { dist = dist * 1.609344 }
                    if (unit=="N") { dist = dist * 0.8684 }
                    return dist;
                }

            },

            updateRetailerList : function()
            {
                let retailerList = [];
                let boutiqueList = [];

                let nearestRetailer = null;
                this.nearestDistance = 0;

                for (let i=0;i<this.retailers.items.length;i++) {

                    // loop through current country code
                    const localRetailers = this.retailers.items[i].retailers;
                    for (let c=0; c<localRetailers.length; c++) {

                        const retailer = localRetailers[c];

                        if (this.retailerIds===null || this.retailerIds.indexOf(retailer.id.toString()) !== -1) {

                            const distance = this.distance(this.lat, this.lng, retailer.lat, retailer.lng, "K");
                            if (this.nearestDistance === 0 || distance < this.nearestDistance) {
                                nearestRetailer = retailer;
                                this.nearestDistance = distance;
                            }
                        }
                    }
                }

                if (nearestRetailer) {
                    if (nearestRetailer.type==="boutique") {
                        boutiqueList.push(nearestRetailer);
                    } else {
                        retailerList.push(nearestRetailer);
                    }
                }


                this.retailerList = retailerList;
                this.boutiqueList = boutiqueList;
            },

            getDayOfTheWeek : function()
            {
                const mapping = {
                    0 : 6, // So
                    1 : 0,  // Mo
                    2 : 1, // Di
                    3 : 2, // Mi
                    4 : 3, // Do
                    5 : 4, // Fr
                    6 : 5, // Sa
                };
                const today = this.today.getDay();
                return mapping[today];
            },

            setupAllowedRetailers : function()
            {
                const el = document.getElementById("vue_nearestRetailer");

                if (typeof el.dataset.retailerids === "string" && el.dataset.retailerids.length) {
                    const tmp = el.dataset.retailerids.split(",");

                    if (typeof tmp === "object" && tmp.length) {
                        this.retailerIds = tmp;
                    }
                }
            },

            getUsersGeoPosition : function()
            {
                if (!navigator.geolocation) {
                  _log('Geolocation is not supported');
                } else {
                    _log('locating ...');
                    const options = {enableHighAccuracy: true, maximumAge: 10000};
                    navigator.geolocation.getCurrentPosition(this.getUsersGeoPosition__success(), this.getUsersGeoPosition__error, options);
                }
            },

            getUsersGeoPosition__success : function(position)
            {
                _log('getUsersGeoPosition__success');
                _log(position.coords.latitude);
                _log(position.coords.longitude);
                this.lat = parseFloat(position.coords.latitude.toFixed(2));
                this.lng = parseFloat( position.coords.longitude.toFixed(2));

                setTimeout(this.updateRetailerList, 2000);
            },

            getUsersGeoPosition__error : function(position)
            {
               _log('geo position not allowed');
            }

        },
        created : function()
        {
            this.setupAllowedRetailers();
            this.getRetailers();
            // this.getUsersGeoPosition();
            //
            //
            navigator.geolocation.getCurrentPosition(
                    this.getUsersGeoPosition__success,
                    this.getUsersGeoPosition__error,
                    {enableHighAccuracy: true, maximumAge: 10000}
            );
        },


    });
}

export { initNearestRetailers };